import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { authFirewallQueryKeys } from '../constants/queryKeys';
import { apiGet } from '../../../../api/queries/apiGet';
import { API_BASE_URL } from '../constants/consts';
import { QueryFilters } from '../types';
import { buildUniversalMfaQueryParams } from '../constants/utils';
import { ProtocolTypeSummary } from '../../types';

const END_POINT = '/metric/protocolTypeSummary';

export type ProtocolTypeSummaryDto = ProtocolTypeSummary;

const fetchProtocolTypeSummary = async (filters: QueryFilters) => {
    const data = await apiGet<ProtocolTypeSummaryDto>(
        `${API_BASE_URL}${END_POINT}`,
        buildUniversalMfaQueryParams(filters)
    );

    return data;
};

export const useProtocolTypeSummary = (filters: QueryFilters): UseQueryResult<ProtocolTypeSummary> => {
    return useQuery({
        queryKey: authFirewallQueryKeys.protocolTypeSummary(filters),
        queryFn: () => fetchProtocolTypeSummary(filters)
    });
};
